import { assign, createMachine } from "xstate"

const initialContext = {
  credenciales: [],
  error: "",
  filtros: [],
  loading: false,
  pagina: 1,
  isFetching: false,
}

const CredencialesMachine = createMachine(
  {
    predictableActionArguments: true,
    context: initialContext,
    id: "Credenciales",
    initial: "idle",
    states: {
      idle: {
        on: {
          "CREDENCIALES/LOGOUT": {
            actions: ["resetMachine"],
            target: "idle",
          },
          "CREDENCIALES/LISTA_CREDENCIALES": {
            actions: ["setLoading"],
            target: "idle",
          },
          "CREDENCIALES/UNSET_LISTA_CREDENCIALES": {
            actions: ["unsetCredenciales"],
            target: "idle",
          },
          "CREDENCIALES/LISTA_CREDENCIALES_SUCCESS": {
            actions: ["setCredenciales", "unsetLoading"],
            target: "idle",
          },
          "CREDENCIALES/LISTA_CREDENCIALES_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          CREDENCIALES_SETFILTRO: {
            actions: ["setFiltros"],
            target: "filtrado",
          },
        },
      },
      filtrado: {
        on: {
          CREDENCIALES_UNSETFILTRO: {
            actions: ["unsetFiltros"],
            target: "idle",
          },
        },
      },
    },
  },
  {
    actions: {
      resetMachine: assign(initialContext),
      setNotificacion: assign({
        error: (_, event) => {
          console.log("CREDENCIALES::setNotificacion")
          return ""
        },
      }),
      setCredenciales: assign({
        credenciales: (_, event) => event.payload.data,
      }),
      unsetcredenciales: assign({
        credenciales: (_, event) => [],
      }),
      setFiltros: assign({
        filtros: (_, event) => event.payload,
      }),
      unsetFiltros: assign({
        filtros: [],
      }),
      setError: assign({
        error: (_, event) => {
          console.log(event.payload)
          return event.payload.response?.data?.Mensaje_Error
            ? event.payload.response?.data?.Mensaje_Error
            : event.payload.message
            ? event.payload.message
            : "Ocurrió un error!"
        },
      }),
      unsetError: assign({
        error: null,
      }),
      setLoading: assign({
        loading: true,
      }),
      unsetLoading: assign({
        loading: false,
      }),
    },
  }
)

export default CredencialesMachine
